import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { createPublisher } from '../../../services/PublisherService'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

export default class PublisherPageAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registerError: null,
      currentUser: null,
      isLoading: true,
      publisher_uuid: '',
      owner_id: '',
      tag: '',
      title: '',
      description: '',
      status: ''
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();

    log.debug(user.displayName)

    this.setState({currentUser: user})
    this.setState({owner_id: user.uid})
    let uuidv4 = getUUIDV4()
    this.setState({publisher_uuid: uuidv4})

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    let publisher = {
      publisher_uuid: this.state.publisher_uuid,
      owner_id: this.state.owner_id,
      tag: this.state.tag,
      title: this.state.title,
      description: this.state.description,
      //date_created: this.date_created,
      status: this.state.status
    }
    log.debug(publisher)

    try{
      let result = await createPublisher(publisher)
      log.debug('save success')
      // redirect to list view.
      this.props.history.push("/publisher")
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/publisher'>Publisher</Link> ->
          Add
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }

          <div className="form-group">
            <label htmlFor="publisher_uuid" className="col-sm-2 control-label">publisher_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="publisher_uuid"
                value={this.state.publisher_uuid}
                onChange={this.handleInputChange}
                placeholder="publisher_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="owner_id" className="col-sm-2 control-label">owner_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="owner_id"
                value={this.state.owner_id}
                onChange={this.handleInputChange}
                placeholder="owner_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tag" className="col-sm-2 control-label">tag:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="tag"
                value={this.state.tag}
                onChange={this.handleInputChange}
                placeholder="tag" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description" />
            </div>
          </div>
          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                ref={(date_created) => this.date_created = date_created}
                defaultValue={getTimeStamp()}
                placeholder="date_created" />
            </div>
          </div> */}
          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status" />
            </div>
          </div>
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Add</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/PublisherPage/PublisherPageAdd.js